import React from 'react';

const CampaignPage = React.lazy(() => import('pages/Campaign/CampaignPage'));
const CampaignLayoutExample = React.lazy(() => import('pages/Campaign/CampaignLayoutExample'));
const CampaignAddPage = React.lazy(() => import('pages/Campaign/CampaignAddPage'));

const Campaign= [
  {
    path: '/campaign',
    exact: true,
    name: 'Danh sách chiến dịch',
    function: 'CRM_CAMPAIGN_VIEW',
    component: CampaignPage,
  },
  {
    path: '/campaign/add',
    exact: true,
    name: 'Thêm mới chiến dịch',
    function: 'CRM_CAMPAIGN_ADD',
    component: CampaignAddPage,
  },
  {
    path: '/campaign/detail/:id',
    exact: true,
    name: 'Chi tiết chiến dịch',
    function: 'CRM_CAMPAIGN_DETAIL',
    component: CampaignAddPage,
  },
  {
    path: '/campaign/edit/:id',
    exact: true,
    name: 'Chỉnh sửa chiến dịch',
    function: 'CRM_CAMPAIGN_EDIT',
    component: CampaignAddPage,
  },  
  {
    path: '/campaign/layout/:id',
    exact: true,
    name: 'Chiến dịch mẫu',
    component: CampaignLayoutExample,
  },
];

export default Campaign;
